export default __webpack_public_path__ + "static/media/pain.37fd2f2c.mp3";